// extracted by mini-css-extract-plugin
export default {"fieldNotificationWithLink":"styles-module__fieldNotificationWithLink__b606f0a89a9484ec1c4a"};